import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConnectivityService } from '../services/connectivity.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private connectivity: ConnectivityService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap({
				next: (event) => {
					// On any successful response, clear "server unreachable"
					if (event instanceof HttpResponse) {
						this.connectivity.setApiUnreachable(false);
					}
				},
			}),
			catchError((error: HttpErrorResponse) => {
				// If the browser is offline, the offline banner will already show via window events
				// Flag server unreachable for network errors (status 0) or server-side failures (5xx)
				if (error.status === 0 || (error.status >= 500 && error.status <= 599)) {
					this.connectivity.setApiUnreachable(true);
				}
				return throwError(() => error);
			}),
		);
	}
}
